var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-filter-advanced-group',{attrs:{"title":"General","count":_vm.count}},[_c('core-filter-input-daterange',{attrs:{"filter":_vm.value('date')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }